import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const ToolsPage = lazy(() =>
  import("@/admin/pages/ToolsPage").then((m) => ({ default: m.ToolsPage })),
);

export const Route = createFileRoute("/admin/tools")({
  component: () => (
    <Suspense fallback={null}>
      <ToolsPage />
    </Suspense>
  ),
});
